import useRedux from "./useRedux";
import { push, replace, go, goBack, goForward } from "react-router-redux";
import { useCallback } from "react";
export default function useRouting() {
    const [state, dispatch] = useRedux(it => it.routing);
    return {
        ...state,
        push: useCallback((location) => dispatch(push(location)), [dispatch]),
        replace: useCallback((location) => dispatch(replace(location)), [dispatch]),
        go: useCallback((n) => dispatch(go(n)), [dispatch]),
        goBack: useCallback(() => dispatch(goBack()), [dispatch]),
        goForward: useCallback(() => dispatch(goForward()), [dispatch]),
    };
}



// WEBPACK FOOTER //
// ./src/assets/scripts/hooks/useRouting.ts